import {
  ROOT,
  ROOM_PLAN_GET_ALL,
  ROOM_PLAN_GET_ALL_AVAILABLE_RATE,
  ROOM_PLAN_UPDATE_AVAILABLE,
  ROOM_PLAN_UPDATE_RATE,
  ROOM_PLAN_UPDATE_STOP_SELL,
  ROOM_PLAN_UPDATE_CLOSED_TO_ARRIVAL,
  ROOM_PLAN_UPDATE_CLOSED_TO_DEPATURE,
  ROOM_PLAN_UPDATE_MIN_STAY,
  ROOM_PLAN_UPDATE_MAX_STAY,
  ROOM_PLAN_UPDATE_ALL,
  ALLOTMENT_UPDATE_ALL,
  CONFIRM_PMS,
  ROOM_RATE_PLAN,
  UPDATE_ROOM_RATE_PLAN,
  ROOM_PLAN_DETAIL_RATE,
  CHECK_QUANTITY,
  ROOM_PLAN_UPDATE_SELL_LIMIT,
  ROOM_PLAN_UPDATE_STOP_SELL_LIMIT,
  ROOM_PLAN_DELETE_STOP_SELL_LIMIT,
  ROOM_PLAN_DELETE_SELL_LIMIT,
} from "@/_helpers/constant.js";
import { requestOptions, handleResponse } from "@/_helpers";

function getAll() {
  return fetch(ROOT + ROOM_PLAN_GET_ALL, requestOptions.get()).then(
    handleResponse
  );
}

function getRoomRate(params) {
  // params.ota = "32000000-0000-0000-0000-000000000000";
  return fetch(ROOT + ROOM_RATE_PLAN, requestOptions.post(params)).then(
    handleResponse
  );
}

function updateRoomRate(params) {
  // params.ota = "32000000-0000-0000-0000-000000000000";
  return fetch(ROOT + UPDATE_ROOM_RATE_PLAN, requestOptions.post(params)).then(
    handleResponse
  );
}

function getDetailRoomRate(params) {
  // params.ota = "32000000-0000-0000-0000-000000000000";
  return fetch(ROOT + ROOM_PLAN_DETAIL_RATE, requestOptions.post(params)).then(
    handleResponse
  );
}

function getAllAvailableRate(params) {
  return fetch(
    ROOT + ROOM_PLAN_GET_ALL_AVAILABLE_RATE,
    requestOptions.post(params)
  ).then(handleResponse);
}

function updateAvailable(data) {
  return fetch(
    ROOT + ROOM_PLAN_UPDATE_AVAILABLE,
    requestOptions.post(data)
  ).then(handleResponse);
}

function updateRate(data) {
  return fetch(ROOT + ROOM_PLAN_UPDATE_RATE, requestOptions.post(data)).then(
    handleResponse
  );
}

function updateStopSell(data, listOta) {
  return fetch(
    ROOT +
    ROOM_PLAN_UPDATE_STOP_SELL +
    "?" +
    new URLSearchParams(listOta.map(s => ["otaIds", s])).toString(),
    requestOptions.post(data)
  ).then(handleResponse);
}

function updateClosedToArrival(data) {
  return fetch(
    ROOT + ROOM_PLAN_UPDATE_CLOSED_TO_ARRIVAL,
    requestOptions.post(data)
  ).then(handleResponse);
}

function updateClosedToDepature(data) {
  return fetch(
    ROOT + ROOM_PLAN_UPDATE_CLOSED_TO_DEPATURE,
    requestOptions.post(data)
  ).then(handleResponse);
}

function updateMinStay(data) {
  return fetch(
    ROOT + ROOM_PLAN_UPDATE_MIN_STAY,
    requestOptions.post(data)
  ).then(handleResponse);
}

function updateMaxStay(data) {
  return fetch(
    ROOT + ROOM_PLAN_UPDATE_MAX_STAY,
    requestOptions.post(data)
  ).then(handleResponse);
}

function updateAll(data) {
  return fetch(ROOT + ROOM_PLAN_UPDATE_ALL, requestOptions.post(data)).then(
    handleResponse
  );
}

function updateAllotment(data) {
  return fetch(ROOT + ALLOTMENT_UPDATE_ALL, requestOptions.post(data)).then(
    handleResponse
  );
}
function confirmPMS(data) {
  return fetch(
    ROOT + CONFIRM_PMS + `?pmsConfirm=${data}`,
    requestOptions.get()
  ).then(handleResponse);
}

function checkQuantity(params) {
  // params.ota = "32000000-0000-0000-0000-000000000000";
  return fetch(ROOT + CHECK_QUANTITY, requestOptions.post(params)).then(
    handleResponse
  );
}

function updateStopSellLimit(data) {
  return fetch(
    ROOT +
    ROOM_PLAN_UPDATE_STOP_SELL_LIMIT,
    requestOptions.post(data)
  ).then(handleResponse);
}

function updateSellLimit(data) {
  return fetch(
    ROOT +
    ROOM_PLAN_UPDATE_SELL_LIMIT,
    requestOptions.post(data)
  ).then(handleResponse);
}

function deleteStopSellLimit(data) {
  return fetch(
    ROOT +
    ROOM_PLAN_DELETE_STOP_SELL_LIMIT,
    requestOptions.post(data)
  ).then(handleResponse);
}

function deleteSellLimit(data) {
  return fetch(
    ROOT +
    ROOM_PLAN_DELETE_SELL_LIMIT,
    requestOptions.post(data)
  ).then(handleResponse);
}

export const service = {
  getDetailRoomRate,
  updateRoomRate,
  getRoomRate,
  getAll,
  getAllAvailableRate,
  updateAvailable,
  updateRate,
  updateStopSell,
  updateClosedToArrival,
  updateClosedToDepature,
  updateMinStay,
  updateMaxStay,
  updateAll,
  updateAllotment,
  confirmPMS,
  checkQuantity,
  updateStopSellLimit,
  updateSellLimit,
  deleteStopSellLimit,
  deleteSellLimit
};
